import en from './strings.en';

const ru = {
    help: 'Помощь',
    howTo: 'Введите параметры поиска и нажмите «Найти перевозчиков»'
};

export default { ru, en: { ...ru, ...en} };
